import PageVideo from './PageVideo';

export default PageVideo;
export * from './PageVideo';
